"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookieOption = exports.STORAGE = void 0;

/** @module Constant */

/**
 * storage constant `USER_TOKEN=rentspreeUserToken`
 * @memberof Constant
 */
var STORAGE = {
  USER_TOKEN: "rentspreeUserToken"
  /**
   * Get cookie option according to domain
   * @param {String} domain the current site domain
   * @returns {Object} cookie option
   * @memberof Constant
   * @function getCookieOption
   */

};
exports.STORAGE = STORAGE;

var getCookieOption = function getCookieOption(domain) {
  return domain === "localhost" ? {
    path: "/"
  } : {
    path: "/",
    domain: domain
  };
};

exports.getCookieOption = getCookieOption;